import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { store } from 'src/infra/stores/store';
import { selectSelectedBilledEntities } from 'src/infra/stores/reducer/billedEntitiesSlice';
import { userStore } from 'src/use-cases/user/userDetails/userStore';
import { getAllEntityCodes } from './getAllEntityCodes';

// Cache for default billed entity to avoid multiple API calls
let defaultBilledEntityCache: string | null = null;
/**
 * Attaches the selected billed entities to every API request
 * Adds the 'x-billed-entity-ids' header with the codes of selected entities
 */
export const attachBilledEntitiesInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const state = store.getState();
    const selectedEntities = selectSelectedBilledEntities(state);
    const entityCodes = getAllEntityCodes(selectedEntities);

    // Check if the request URL contains the excluded path
    const isExcludedPath = config.url && (config.url.includes('legal-entities/billed-entities/filter') || config.url.includes('/api/logged-in-user'));

    // If there are selected entities, use them
    if (entityCodes.length > 0 && !isExcludedPath) {
      config.headers['x-billed-entity-ids'] = entityCodes.join(',');
      return config;
    }

    // If no entities are selected, try to get the default billed entity from the user profile in Redux store
    if (!isExcludedPath) {
      // Check if we have a cached default billed entity
      if (defaultBilledEntityCache) {
        config.headers['x-billed-entity-ids'] = defaultBilledEntityCache;
        return config;
      }

      // Get default billed entity ID from userStore
      const defaultBilledEntityId = userStore.getDefaultBilledEntityId();

      // If a default billed entity is available, use it
      if (defaultBilledEntityId) {
        // Cache the default billed entity ID
        defaultBilledEntityCache = defaultBilledEntityId;

        // Add the default billed entity ID to the header
        config.headers['x-billed-entity-ids'] = defaultBilledEntityCache;
      }
    }
    // The header will be added based on the logic above

    return config;
  });
};
